import { useState, type FormEvent } from "react"
import { useNavigate, Navigate, Link } from "react-router-dom"
import { LogIn } from "lucide-react"
import { useAuth } from "../../hooks/useAuth"
import AuthCard, { AuthFormError } from "./AuthCard"

export default function LoginPage() {
  const { login, user } = useAuth()
  const navigate = useNavigate()
  const [email, setEmail] = useState("")
  const [password, setPassword] = useState("")
  const [error, setError] = useState("")
  const [loading, setLoading] = useState(false)

  if (user) {
    const dest = user.role === "member" ? "/member" : "/dashboard"
    return <Navigate to={dest} replace />
  }

  async function handleSubmit(e: FormEvent) {
    e.preventDefault()
    setError("")
    setLoading(true)
    try {
      const result = await login(email, password)
      navigate(result === "member" ? "/member" : "/dashboard", { replace: true })
    } catch {
      setError("Email o contraseña incorrectos.")
    } finally {
      setLoading(false)
    }
  }

  return (
    <AuthCard title="Science Fitness" subtitle="Portal del Entrenador">
      <form onSubmit={handleSubmit} className="space-y-5">
        <div>
          <label className="mb-1.5 block text-xs font-medium text-muted uppercase tracking-wide">
            Email
          </label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="trainer@sciencefitness.com"
            required
            className="w-full rounded-lg border border-white/10 bg-surface-elevated px-4 py-3 text-white placeholder-muted/50 focus:border-primary"
          />
        </div>

        <div>
          <div className="mb-1.5">
            <label className="text-xs font-medium text-muted uppercase tracking-wide">
              Contraseña
            </label>
          </div>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            className="w-full rounded-lg border border-white/10 bg-surface-elevated px-4 py-3 text-white placeholder-muted/50 focus:border-primary"
          />
        </div>

        <AuthFormError error={error} />

        <button
          type="submit"
          disabled={loading}
          className="w-full flex items-center justify-center gap-2 rounded-lg bg-primary py-3 font-semibold text-black transition hover:opacity-90 glow-cyan disabled:opacity-50"
        >
          <LogIn size={16} />
          {loading ? "Ingresando..." : "Iniciar Sesión"}
        </button>
      </form>

      <div className="mt-6 flex flex-col items-center gap-2 text-sm text-muted">
        <Link to="/forgot-password" className="text-primary hover:text-primary/80 transition">
          ¿Olvidaste tu contraseña?
        </Link>
      </div>
    </AuthCard>
  )
}
